import React from "react";
import type { LeadStatus } from "../types";

interface LeadStatusBadgeProps {
  status: LeadStatus;
  size?: "sm" | "md";
}

const STATUS_CONFIG: Record<LeadStatus, { label: string; color: string }> = {
  new: { label: "Новый", color: "bg-blue-100 text-blue-700" },
  contacted: { label: "Связались", color: "bg-purple-100 text-purple-700" },
  in_progress: { label: "В работе", color: "bg-amber-100 text-amber-700" },
  qualified: { label: "Квалифицирован", color: "bg-indigo-100 text-indigo-700" },
  closed: { label: "Закрыт", color: "bg-emerald-100 text-emerald-700" },
  rejected: { label: "Отклонён", color: "bg-gray-100 text-gray-600" },
};

export function LeadStatusBadge({ status, size = "md" }: LeadStatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  const sizeClass = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5";

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${config.color} ${sizeClass}`}>
      {config.label}
    </span>
  );
}
